import { InjectionToken } from "@angular/core";

export interface DigitalCertificateRegistration {
    register(): void;
}

export const DIGITAL_CERTIFICATE_REGISTRATION = new InjectionToken<DigitalCertificateRegistration>(
    "DIGITAL_CERTIFICATE_REGISTRATION"
);
